import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MixinFocusVisible } from '../structure/DefaultStyles';
import { MixinTruncate } from '../text/Typography';

export const MixinMenuBaseLink = css`
    text-decoration: none;

    ${MixinFocusVisible}
    &:hover,
    &:focus {
        text-decoration: underline;
    }
`;

export const MixinMenuFlexContainer = css`
    display: flex;
    align-items: center;
`;

export const MixinMenuMediaHide = css`
    @media (max-width: 768px) {
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        height: 0px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 0px;
        padding: 0;
        margin: 0;
    }
`;

export const MenuActiveBar = styled.span<{ isActive: boolean; isSubActive: boolean }>`
    flex-shrink: 0;
    width: 6px;
    min-width: 6px;
    max-width: 6px;
    height: 30px;
    margin: 0.25rem 0;
    background-color: ${(props) => (props.isActive ? props.theme.color.accent : 'transparent')};
`;

export const MenuTruncate = styled.span`
    ${MixinTruncate}
    padding: 0 0.25rem 0 0;
    ${MixinMenuMediaHide}
`;
